import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectStatuses() {
      return getState().statuses;
    },
    isProjectStatusesRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isProjectStatusesRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isProjectStatusesRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
